import { TileBase } from "../Ground Tiles/TileBase";
import { ViewCellMapRow } from "./ViewCellMapRow";
import { MapCell as PredefinedMapCell, eCellType } from "../Game Map/MapCell";
import { ViewCellMap } from "./ViewCellMap";
import { Platform } from "../Platforms/Platform";



export class ViewCellMapCell {
    /**
     * (RO) Index bunky v ramci radky
     */
    get cellId(): number { return this._cellId; }
    private _cellId: number;

    /**
     * (RO) Radka, do ktere bunka patri
     */
    get row(): ViewCellMapRow { return this._row; }
    private _row: ViewCellMapRow;

    /**
     * (RO) Typ bunky
     */
    get type(): eCellType { return this._type; }
    private _type: eCellType;

    /**
     * (RO) Dlazdice zeme
     */
    get groundTile(): TileBase { return this._groundTile; }
    private _groundTile: TileBase;

    /**
     * (RO) Reference na pohyblivou plosinu, pokud plosina zacina na teto bunce
     */
    get platform(): Platform { return this._platform; }
    set platform(plat: Platform) {
        if ((this._platform = plat)) {
            this._type = eCellType.platform;
        }
        else {
            this._type = eCellType.empty;
        }
    }
    private _platform: Platform;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(cellId: number, row: ViewCellMapRow, data: PredefinedMapCell) {
        this._cellId = cellId;
        this._row = row;

        if ((this._type = data.cellType) == eCellType.tile) {
            // Nastavit dlazdici
            this._groundTile = ViewCellMap.instance.getFreeTile(data.tileType);
            this._groundTile.init(this, data);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    release(): void {
        if (this._groundTile) {
            ViewCellMap.instance.releaseTile(this._groundTile);
            this._groundTile = undefined;
            this._platform = undefined;
        }

        if (this._platform) {
            this._platform.release();
            this._platform = undefined;
        }
    }
}